export default __webpack_public_path__ + "static/payrouse-89e872c6ff91aa68833fdcb590e72085.png";